require("!!/home/uplanner/rosario-front/node_modules/script-loader/addScript.js")(require("!!/home/uplanner/rosario-front/node_modules/raw-loader/index.js!/home/uplanner/rosario-front/bower_components/moment/moment.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./bower_components/moment/moment.js
// module id = 1517
// module chunks = 0